import {useMemo} from "react";

import {useGetRegionsQuery} from "@/features/regions/api/get_regions_api";

import {useGetHomeMatchPreferencesQuery} from "../../api/get_home_match_preferences";
import {transformHomeMatchApiIntoFormData} from "../../utils/transform_home_match_api_into_form_data";

export const useHomeMatchPreferencesWithRegions = () => {
    const {
        data: preferencesData,
        isLoading: isLoadingPreferences,
        isError: isPreferencesError,
        refetch: refetchHomeMatchPreferences
    } = useGetHomeMatchPreferencesQuery();

    const regionIds = useMemo(() => {
        return preferencesData?.regions || [];
    }, [preferencesData?.regions]);
    const {data: regionsResponse, isLoading: isLoadingRegions, isError: isRegionsError} = useGetRegionsQuery({regionIds}, {skip: regionIds.length === 0});

    const combinedData = useMemo(() => {
        if (!preferencesData) {
            return {
                preferences: null,
                regionDetails: []
            };
        }

        const regionDetails = regionsResponse?.results || [];
        const transformedPreferences = transformHomeMatchApiIntoFormData(preferencesData, regionDetails);

        return {
            preferences: transformedPreferences,
            regionDetails
        };
    }, [preferencesData, regionsResponse?.results]);

    const isLoading = isLoadingPreferences || (regionIds.length > 0 && isLoadingRegions);
    const isError = isPreferencesError || isRegionsError;

    return {
        preferences: combinedData.preferences,
        regionDetails: combinedData.regionDetails,
        isLoading,
        isError,
        refetchHomeMatchPreferences
    };
};
import {useMemo} from "react";

import {useGetRegionsQuery} from "@/features/regions/api/get_regions_api";

import {useGetHomeMatchPreferencesQuery} from "../../api/get_home_match_preferences";
import {transformHomeMatchApiIntoFormData} from "../../utils/transform_home_match_api_into_form_data";

export const useHomeMatchPreferencesWithRegions = () => {
    const {
        data: preferencesData,
        isLoading: isLoadingPreferences,
        isError: isPreferencesError,
        refetch: refetchHomeMatchPreferences
    } = useGetHomeMatchPreferencesQuery();

    const regionIds = useMemo(() => {
        return preferencesData?.regions || [];
    }, [preferencesData?.regions]);
    const {data: regionsResponse, isLoading: isLoadingRegions, isError: isRegionsError} = useGetRegionsQuery({regionIds}, {skip: regionIds.length === 0});

    const combinedData = useMemo(() => {
        if (!preferencesData) {
            return {
                preferences: null,
                regionDetails: []
            };
        }

        const regionDetails = regionsResponse?.results || [];
        const transformedPreferences = transformHomeMatchApiIntoFormData(preferencesData, regionDetails);

        return {
            preferences: transformedPreferences,
            regionDetails
        };
    }, [preferencesData, regionsResponse?.results]);

    const isLoading = isLoadingPreferences || (regionIds.length > 0 && isLoadingRegions);
    const isError = isPreferencesError || isRegionsError;

    return {
        preferences: combinedData.preferences,
        regionDetails: combinedData.regionDetails,
        isLoading,
        isError,
        refetchHomeMatchPreferences
    };
};
